import { useEffect, useState } from 'react'
import { buildWorkflowFormQuestions, buildWorkflowByIdMap, WorkflowFormQuestion } from '../../../../utilsComponents/workflowParser'

/**
 * Parses the raw JSON from the workflow (defined on the back end) and extracts:
 * - `workflowQuestions`: the ordered list of questions that can be displayed to the user
 * - `rawByIdMap`: a map of all workflow nodes (questions +
 *   such as redirects or calculations), indexed by ID, used
 *   to navigate the workflow graph (triggers, auto-next, etc.)
 *
 * Runs again whenever `workflowJsonContent` changes (e.g., initial
 * loading of the data from the API).
 */
export function useWorkflowQuestions(workflowJsonContent: any) {
    const [workflowQuestions, setWorkflowQuestions] = useState<WorkflowFormQuestion[]>([])
    const [rawByIdMap, setRawByIdMap] = useState<Map<string, any>>(new Map())

    useEffect(() => {
        if (!workflowJsonContent) {
            setWorkflowQuestions([])
            setRawByIdMap(new Map())
            return
        }
        setWorkflowQuestions(buildWorkflowFormQuestions(workflowJsonContent))
        setRawByIdMap(buildWorkflowByIdMap(workflowJsonContent))
    }, [workflowJsonContent])

    return { workflowQuestions, rawByIdMap }
}
